import React, {RefObject, useCallback, useEffect, useRef, useState} from 'react'
import FieldSelectTask_Popover_Search from './search'
import {EntitySelectorListType} from '../../../../../gd-components/entity-selector/@const'
import Task from '../../../../../model2/task/task'
import FieldSelectTask_Popover_SelectorTaskList from './list'


type Props = {
    projectId?      : ID
    onEntitySelected: {(entity:Task):void}
}

const debug = false
// const debug = "FieldSelectTask_Popover_Selector"

export default function FieldSelectTask_Popover_Selector (props:Props) {
    const [search, setSearch]       = useState('')
    const [listType, setListType]   = useState(EntitySelectorListType.RECENT)
    const listRef                   = useRef<any>()

    const onSearchChanged = useCallback((search:string)=>{
        setSearch(search)
    }, [])

    const onTypeChanged = useCallback((type:EntitySelectorListType)=>{
        setListType(type)
    }, [])

    const taskFinderRef:RefObject<any> = useRef()

    useEffect(() => {
        const searchString = search?.toLowerCase()
        taskFinderRef.current?.onSearchChange(searchString)
    }, [search]);

    const onKeyDown = useCallback((event: any)=>{
        listRef.current.onKeyDown(event)
    }, [listRef.current])

    return (
        <>

            <FieldSelectTask_Popover_Search
                listType            = {listType}
                onKeyDown           = {onKeyDown}
                onSearchChanged     = {onSearchChanged}
                onTypeChanged       = {onTypeChanged}
            />

            <FieldSelectTask_Popover_SelectorTaskList
                ref                = {listRef}
                search             = {search}
                listType           = {listType}
                parentProjectId    = {props.projectId}
                onEntitySelected   = {props.onEntitySelected}
            />

        </>
    )
}
